import initialState from './initialState';
import {
  RECEIVE_ERROR_IN_VENDOR_FILE_IMPORT,
  HIDE_ERROR_DIALOG,
  RECEIVE_ERROR_IN_FILE_TRANSFER_DETAILS_FETCH,
  RECEIVE_ERROR_IN_VENDOR_FILE_LOG_FETCH,
  RECEIVE_ERROR_IN_832_FILES_FETCH,
  RECEIVE_ERROR_IN_REPORT_DETAILS_FETCH,
  RECEIVE_ERROR_IN_USER_PROFILE_DETAILS_FETCH,
  RECEIVE_ERROR_IN_USER_GROUP_DETAILS_FETCH,
  RECEIVE_ERROR_IN_USERS_FETCH,
  RECEIVE_ERROR_IN_ALL_USER_GROUPS_FETCH,
  RECEIVE_ERROR_WHEN_SAVING_USER_MANAGEMENT_DETAILS,
  RECEIVE_ERROR_IN_USER_PROFILE_DETAILS_FETCH_OF_SELECTED_USER,
  RECEIVE_ERROR_IN_VENDORS_FETCH,
  RECEIVE_ERROR_IN_OPCO_FETCH,
  RECEIVE_ERROR_IN_REPORT_TEMPLATE_CREATION, RECEIVE_ERROR_IN_REPORT_TEMPLATE_DELETION,
  RECEIVE_ERROR_IN_BUSINESS_CENTERS_FETCH,
  RECEIVE_ERROR_IN_PRICE_RECORD_TYPES_FETCH,
  RECEIVE_ERROR_IN_SUPPLIER_SUPPORT_REQUEST_SUBMISSION,
  RECEIVE_ERROR_IN_HELP_TOPIC_CONTENT_FETCH,
  RECEIVE_ERROR_IN_REQUEST_DETAILS_FETCH,
  RECEIVE_ERROR_IN_WORKSPACE_REQUEST_SUBMISSION,
  RECEIVE_ERROR_IN_COST_DATA_FETCH,
  RECEIVE_ERROR_IN_ADHOC_COST_FILE_IMPORT,
  RECEIVE_ERROR_IN_ITEMS_VALIDATION,
  CLEAR_ITEMS_VALIDATION_ERROR,
  RECEIVE_ERROR_IN_REQUEST_STATUS_UPDATE,
  RECEIVE_ERROR_IN_WORKSPACE_REQUEST_ACTION_CHANGE,
  RECEIVE_ERROR_IN_WORKSPACE_REQUEST_COMMENT_SUBMISSION,
  RECEIVE_FILE_LOADING_ERROR,
  RECEIVE_ERROR_IN_ENTERPRISE_COST_MASTER_DATA_FETCH,
  RECEIVE_ERROR_IN_ENTERPRISE_COST_DATA_FETCH,
  RECEIVE_ERROR_IN_EARNED_INCOME_MAPPINGS_FETCH,
  RECEIVE_ERROR_IN_SAS_FD_DETAILS_FETCH,
  RECEIVE_ERROR_WHEN_SAVING_VENDOR_SAS_DETAILS,
  RECEIVE_ERROR_WHEN_ADDING_VENDOR_SAS_DETAILS,
  RECEIVE_ERROR_WHEN_SAVING_ITEM_SAS_FD_DETAILS,
  RECEIVE_ERROR_IN_SAS_FD_FILE_IMPORT,
  RECEIVE_ERROR_IN_SUPPLIER_ONBOARD_DETAILS_FETCH,
  RECEIVE_ERROR_IN_USER_ASSOCIATION_AND_BUSINESS_CENTER_CONTACTS_FETCH,
  RECEIVE_ERROR_UPDATE_SUPPLIER_CONTACT,
  RECEIVE_ERROR_IN_AGREEMENT_NUMBERS,
  RECEIVE_ERROR_IN_AGREEMENT_DETAILS,
  RECEIVE_ERROR_IN_AGREEMENT_UPDATE,
  RECEIVE_ERROR_IN_AGREEMENT_CREATE,
  RECEIVE_ERROR_IN_AGREEMENT_RECALCULATE,
  RECEIVE_ERROR_IN_AGREEMENT_RECALCULATION_DECLINE,
  RECEIVE_ERROR_IN_AGREEMENT_DELETE,
  RECEIVE_ERROR_IN_POST_COMMENT,
  RECEIVE_ERROR_IN_AGREEMENTS_SEARCH_DATA_FETCH,
  RECEIVE_ERROR_IN_AGREEMENT_REPORT_CREATION,
  RECEIVE_ERROR_IN_MASS_ITEM_UPLOAD_REQUEST,
  RECEIVE_ERROR_IN_AGREEMENT_CLONE,
  RECEIVE_ERROR_IN_EXCEPTIONS,
  RECEIVE_EXCEPTIONS_SAVE_ERROR,
  RECEIVE_EXCEPTIONS_DELETE_ERROR,
  RECEIVE_ERROR_IN_EXCEPTION_CODES,
  RECEIVE_ERROR_IN_COST_IMPACT_TERM_FILE_IMPORT,
  RECEIVE_ERROR_IN_EI_TERM_DETAILS_FETCH,
  RECEIVE_ERROR_IN_FORMULA_GROUP_REQUEST,
  RECEIVE_ERROR_IN_MODULE_PRICE_IMPORT,
  RECEIVE_ERROR_IN_MODULES_FETCH,
  RECEIVE_ERROR_IN_MODULE_PRICE_EXPORT,
  RECEIVE_ERROR_IN_ITEM_PRICE,
  RECEIVE_ERROR_IN_MODULE_GROUP_CREATE,
  RECEIVE_ERROR_IN_COMMODITIES_FETCH,
  RECEIVE_ERROR_IN_COMMODITY_GROUP_CREATE,
  RECEIVE_ERROR_IN_COMMODITY_GROUP_FETCH,
  RECEIVE_ERROR_IN_MODULE_GROUPS_ASSOCIATION_FETCH,
  RECEIVE_ERROR_IN_MODULE_GROUP_UPDATE,
  RECEIVE_ERROR_IN_MODULE_GROUP_DELETE,
  RECEIVE_ERROR_IN_LOADING_AREAS_FETCH,
  RECEIVE_ERROR_IN_MODULE_GROUP_COMMODITY_ASSIGNMENT,
  RECEIVE_ERROR_IN_MODULE_GROUP_LOADING_AREA_ASSIGNMENT,
  RECEIVE_ERROR_IN_COMMODITY_GROUP_UPDATE,
  RECEIVE_ERROR_IN_COMMODITY_GROUP_DELETE,
  RECEIVE_ERROR_IN_COMMODITY_GROUP_ITEM_ASSIGNMENT,
  RECEIVE_ERROR_IN_PRICE_MODULE_ITEMS_FETCH,
  RECEIVE_ERROR_IN_MODULE_GROUP_REACTIVATE,
  RECEIVE_ERROR_IN_COMMODITY_GROUP_REACTIVATE,
  RECEIVE_ERROR_IN_LOADING_AREA_DETAILS_FETCH,
  RECEIVE_ERROR_IN_LOADING_AREA_UPDATE,
  RECEIVE_ERROR_IN_LOADING_AREA_DELETE,
  RECEIVE_ERROR_IN_LOADING_AREA_CREATE,
  RECEIVE_ERROR_IN_LOADING_AREA_REACTIVATE,
  RECEIVE_ERROR_IN_COST_VIEW_DATA_FETCH,
  RECEIVE_ERROR_IN_COST_VIEW_DETAILED_DATA_FETCH,
  RECEIVE_ERROR_IN_SEGMENT_DETAILS_CODES_FETCH,
  RECEIVE_ERROR_IN_SEGMENT_DETAILS_FETCH,
  RECEIVE_ERROR_IN_SEGMENT_DETAILS_CREATION,
  RECEIVE_ERROR_IN_SEGMENT_DETAILS_UPDATE,
  RECEIVE_ERROR_IN_SEGMENT_DETAILS_DELETION,
  RECEIVE_ERROR_IN_SEGMENT_DETAILS_FETCH_DELETED,
  RECEIVE_ERROR_IN_MODULE_PRICES_UPDATE,
} from '../actions/errorDialogActions';
import {
  RECEIVE_ERROR_IN_ITEM_GROUPS,
  RECEIVE_ERROR_IN_ITEM_GROUP_FETCH,
  RECEIVE_ITEM_GROUP_CREATE_ERROR,
  RECEIVE_ITEM_GROUP_DELETE_ERROR,
  RECEIVE_ITEM_GROUP_UPDATE_ERROR,
  RECEIVE_VENDOR_ITEMS_FETCH_ERROR
} from '../actions/agreementActions';

export default function errorReducer(state, { type, data }) {
  if (typeof state === 'undefined') {
    return initialState.error;
  }
  switch (type) {
    case RECEIVE_ERROR_IN_VENDOR_FILE_IMPORT:
    case RECEIVE_ERROR_IN_FILE_TRANSFER_DETAILS_FETCH:
    case RECEIVE_ERROR_IN_VENDOR_FILE_LOG_FETCH:
    case RECEIVE_ERROR_IN_832_FILES_FETCH:
    case RECEIVE_ERROR_IN_REPORT_DETAILS_FETCH:
    case RECEIVE_ERROR_IN_USER_PROFILE_DETAILS_FETCH:
    case RECEIVE_ERROR_IN_USER_GROUP_DETAILS_FETCH:
    case RECEIVE_ERROR_IN_USERS_FETCH:
    case RECEIVE_ERROR_IN_ALL_USER_GROUPS_FETCH:
    case RECEIVE_ERROR_WHEN_SAVING_USER_MANAGEMENT_DETAILS:
    case RECEIVE_ERROR_IN_VENDORS_FETCH:
    case RECEIVE_ERROR_IN_OPCO_FETCH:
    case RECEIVE_ERROR_IN_USER_PROFILE_DETAILS_FETCH_OF_SELECTED_USER:
    case RECEIVE_ERROR_IN_REPORT_TEMPLATE_DELETION:
    case RECEIVE_ERROR_IN_BUSINESS_CENTERS_FETCH:
    case RECEIVE_ERROR_IN_PRICE_RECORD_TYPES_FETCH:
    case RECEIVE_ERROR_IN_SUPPLIER_SUPPORT_REQUEST_SUBMISSION:
    case RECEIVE_ERROR_IN_HELP_TOPIC_CONTENT_FETCH:
    case RECEIVE_ERROR_IN_REQUEST_DETAILS_FETCH:
    case RECEIVE_ERROR_IN_WORKSPACE_REQUEST_SUBMISSION:
    case RECEIVE_ERROR_IN_COST_DATA_FETCH:
    case RECEIVE_ERROR_IN_ADHOC_COST_FILE_IMPORT:
    case RECEIVE_ERROR_IN_REQUEST_STATUS_UPDATE:
    case RECEIVE_ERROR_IN_WORKSPACE_REQUEST_ACTION_CHANGE:
    case RECEIVE_ERROR_IN_WORKSPACE_REQUEST_COMMENT_SUBMISSION:
    case RECEIVE_FILE_LOADING_ERROR:
    case RECEIVE_ERROR_IN_ENTERPRISE_COST_MASTER_DATA_FETCH:
    case RECEIVE_ERROR_IN_ENTERPRISE_COST_DATA_FETCH:
    case RECEIVE_ERROR_IN_EARNED_INCOME_MAPPINGS_FETCH:
    case RECEIVE_ERROR_IN_SAS_FD_DETAILS_FETCH:
    case RECEIVE_ERROR_WHEN_SAVING_VENDOR_SAS_DETAILS:
    case RECEIVE_ERROR_WHEN_ADDING_VENDOR_SAS_DETAILS:
    case RECEIVE_ERROR_WHEN_SAVING_ITEM_SAS_FD_DETAILS:
    case RECEIVE_ERROR_IN_SAS_FD_FILE_IMPORT:
    case RECEIVE_ERROR_IN_USER_ASSOCIATION_AND_BUSINESS_CENTER_CONTACTS_FETCH:
    case RECEIVE_ERROR_UPDATE_SUPPLIER_CONTACT:
    case RECEIVE_ERROR_IN_AGREEMENT_NUMBERS:
    case RECEIVE_ERROR_IN_AGREEMENT_DETAILS:
    case RECEIVE_ERROR_IN_AGREEMENT_UPDATE:
    case RECEIVE_ERROR_IN_AGREEMENT_CREATE:
    case RECEIVE_ERROR_IN_AGREEMENT_CLONE:
    case RECEIVE_ERROR_IN_AGREEMENT_RECALCULATE:
    case RECEIVE_ERROR_IN_AGREEMENT_RECALCULATION_DECLINE:
    case RECEIVE_ERROR_IN_AGREEMENT_DELETE:
    case RECEIVE_ERROR_IN_POST_COMMENT:
    case RECEIVE_ERROR_IN_AGREEMENTS_SEARCH_DATA_FETCH:
    case RECEIVE_ERROR_IN_AGREEMENT_REPORT_CREATION:
    case RECEIVE_ERROR_IN_ITEM_GROUPS:
    case RECEIVE_ERROR_IN_ITEM_GROUP_FETCH:
    case RECEIVE_VENDOR_ITEMS_FETCH_ERROR:
    case RECEIVE_ITEM_GROUP_CREATE_ERROR:
    case RECEIVE_ITEM_GROUP_UPDATE_ERROR:
    case RECEIVE_ITEM_GROUP_DELETE_ERROR:
    case RECEIVE_ERROR_IN_MASS_ITEM_UPLOAD_REQUEST:
    case RECEIVE_ERROR_IN_EXCEPTIONS:
    case RECEIVE_EXCEPTIONS_SAVE_ERROR:
    case RECEIVE_EXCEPTIONS_DELETE_ERROR:
    case RECEIVE_ERROR_IN_EXCEPTION_CODES:
    case RECEIVE_ERROR_IN_COST_IMPACT_TERM_FILE_IMPORT:
    case RECEIVE_ERROR_IN_EI_TERM_DETAILS_FETCH:
    case RECEIVE_ERROR_IN_FORMULA_GROUP_REQUEST:
    case RECEIVE_ERROR_IN_MODULE_PRICE_IMPORT:
    case RECEIVE_ERROR_IN_MODULES_FETCH:
    case RECEIVE_ERROR_IN_MODULE_PRICE_EXPORT:
    case RECEIVE_ERROR_IN_ITEM_PRICE:
    case RECEIVE_ERROR_IN_MODULE_GROUP_CREATE:
    case RECEIVE_ERROR_IN_COMMODITIES_FETCH:
    case RECEIVE_ERROR_IN_COMMODITY_GROUP_CREATE:
    case RECEIVE_ERROR_IN_COMMODITY_GROUP_FETCH:
    case RECEIVE_ERROR_IN_MODULE_GROUPS_ASSOCIATION_FETCH:
    case RECEIVE_ERROR_IN_MODULE_GROUP_UPDATE:
    case RECEIVE_ERROR_IN_MODULE_GROUP_DELETE:
    case RECEIVE_ERROR_IN_MODULE_GROUP_COMMODITY_ASSIGNMENT:
    case RECEIVE_ERROR_IN_MODULE_GROUP_LOADING_AREA_ASSIGNMENT:
    case RECEIVE_ERROR_IN_LOADING_AREAS_FETCH:
    case RECEIVE_ERROR_IN_COMMODITY_GROUP_UPDATE:
    case RECEIVE_ERROR_IN_COMMODITY_GROUP_DELETE:
    case RECEIVE_ERROR_IN_COMMODITY_GROUP_ITEM_ASSIGNMENT:
    case RECEIVE_ERROR_IN_PRICE_MODULE_ITEMS_FETCH:
    case RECEIVE_ERROR_IN_LOADING_AREA_DETAILS_FETCH:
    case RECEIVE_ERROR_IN_LOADING_AREA_CREATE:
    case RECEIVE_ERROR_IN_LOADING_AREA_DELETE:
    case RECEIVE_ERROR_IN_LOADING_AREA_UPDATE:
    case RECEIVE_ERROR_IN_MODULE_GROUP_REACTIVATE:
    case RECEIVE_ERROR_IN_COMMODITY_GROUP_REACTIVATE:
    case RECEIVE_ERROR_IN_LOADING_AREA_REACTIVATE:
    case RECEIVE_ERROR_IN_COST_VIEW_DATA_FETCH:
    case RECEIVE_ERROR_IN_COST_VIEW_DETAILED_DATA_FETCH:
    case RECEIVE_ERROR_IN_SEGMENT_DETAILS_CODES_FETCH:
    case RECEIVE_ERROR_IN_SEGMENT_DETAILS_FETCH:
    case RECEIVE_ERROR_IN_SEGMENT_DETAILS_CREATION:
    case RECEIVE_ERROR_IN_SEGMENT_DETAILS_UPDATE:
    case RECEIVE_ERROR_IN_SEGMENT_DETAILS_DELETION:
    case RECEIVE_ERROR_IN_SEGMENT_DETAILS_FETCH_DELETED:
    case RECEIVE_ERROR_IN_MODULE_PRICES_UPDATE:
      return { show: true, message: data };

    case RECEIVE_ERROR_IN_SUPPLIER_ONBOARD_DETAILS_FETCH:
      return { show: true, message: data, isSupplierOnboardDetailsFetchFailed: true };

    case RECEIVE_ERROR_IN_REPORT_TEMPLATE_CREATION:
    case RECEIVE_ERROR_IN_ITEMS_VALIDATION:
      return { show: true, message: data, type: 'text' };

    case HIDE_ERROR_DIALOG:
    case CLEAR_ITEMS_VALIDATION_ERROR:
      return { show: false, message: '' };

    default:
      return state;
  }
}
